"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currency_format_config_1 = require("./currency-format-config");
exports.isWholeNumber = function (value) { return Math.floor(value) === value; };
exports.getCurrencyFormatConfig = function (currencyCode) {
    return currency_format_config_1.currencyFormatConfig[currencyCode] || currency_format_config_1.defaultCurrencyFormatConfig;
};
exports.getFormattedPriceValue = function (value, currencyCode) {
    var config = exports.getCurrencyFormatConfig(currencyCode);
    return value.toFixed(!exports.isWholeNumber(value) ? config.decimalDigits : 0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
exports.getFormattedPrice = function (value, currencyCode) {
    var config = exports.getCurrencyFormatConfig(currencyCode);
    return config.format
        .replace(currency_format_config_1.VALUE_PLACEHOLDER, exports.getFormattedPriceValue(value, currencyCode))
        .replace(currency_format_config_1.CURRENCY_CODE_PLACEHOLDER, currencyCode);
};
exports.getFormattedMoney = function (money) {
    return exports.getFormattedPrice(Number(money.amount), money.currency);
};
